export default {"src":"/_next/static/media/BM-Logo-white.e7cc3fd6.svg","height":37,"width":38};